<div class="container">
  <h2 class="my-5">Accommodations</h2>

  <section id="resort">
    <h3 class="mb-3">Resorts <sup class="fs-5">(1)</sup></h3>

    <div class="row">
      <div class="card col-md-3">
        <div class="card-header">
          <h4>Hilton Taniti</h4>
        </div>
        <div class="card-content">
          <img src="../../../../assets/images/elementor-placeholder-image.webp" class="card-img">
        </div>
        <div class="card-footer">
          <a class="btn btn-outline-primary" href="https://www.hilton.com/en/resorts/" target="_blank">Book Now</a>
        </div>
      </div>
    </div>

  </section>

  <hr class="my-5">

  <section class="mt-5" id="hotel">
    <h3 class="mb-3">Hotels <sup class="fs-5">(4)</sup></h3>

    <div class="row gap-2">
      <div class="card col-md-3">
        <div class="card-header">
          <h4>The Taniti Inn</h4>
        </div>
        <div class="card-content">
          <img src="../../../../assets/images/elementor-placeholder-image.webp" class="card-img">
        </div>
        <div class="card-footer">
          <a class="btn btn-outline-primary" href="https://www.hilton.com/en/resorts/" target="_blank">Book Now</a>
        </div>
      </div>

      <div class="card col-md-3">
        <div class="card-header">
          <h4>The Tanitian</h4>
        </div>
        <div class="card-content">
          <img src="../../../../assets/images/elementor-placeholder-image.webp" class="card-img">
        </div>
        <div class="card-footer">
          <a class="btn btn-outline-primary" href="#" target="_blank">Book Now</a>
        </div>
      </div>

      <div class="card col-md-3">
        <div class="card-header">
          <h4>Yellow Leaf Hotel</h4>
        </div>
        <div class="card-content">
          <img src="../../../../assets/images/elementor-placeholder-image.webp" class="card-img">
        </div>
        <div class="card-footer">
          <a class="btn btn-outline-primary" href="#" target="_blank">Book Now</a>
        </div>
      </div>

      <div class="card col-md-3">
        <div class="card-header">
          <h4>The Volcano Inn</h4>
        </div>
        <div class="card-content">
          <img src="../../../../assets/images/elementor-placeholder-image.webp" class="card-img">
        </div>
        <div class="card-footer">
          <a class="btn btn-outline-primary" href="#" target="_blank">Book Now</a>
        </div>
      </div>
    </div>

  </section>

  <hr class="my-5">

  <section class="mt-5" id="bandb">
    <h3 class="mb-3">Bed &amp; Breakfast <sup class="fs-5">(3)</sup></h3>

    <div class="row gap-2">
      <div class="card col-md-3">
        <div class="card-header">
          <h4>The Den</h4>
        </div>
        <div class="card-content">
          <img src="../../../../assets/images/elementor-placeholder-image.webp" class="card-img">
        </div>
        <div class="card-footer">
          <a class="btn btn-outline-primary" href="https://www.airbnb.com/" target="_blank">Book Now</a>
        </div>
      </div>

      <div class="card col-md-3">
        <div class="card-header">
          <h4>The Happy House</h4>
        </div>
        <div class="card-content">
          <img src="../../../../assets/images/elementor-placeholder-image.webp" class="card-img">
        </div>
        <div class="card-footer">
          <a class="btn btn-outline-primary" href="https://www.airbnb.com/" target="_blank">Book Now</a>
        </div>
      </div>

      <div class="card col-md-3">
        <div class="card-header">
          <h4>The Villages</h4>
        </div>
        <div class="card-content">
          <img src="../../../../assets/images/elementor-placeholder-image.webp" class="card-img">
        </div>
        <div class="card-footer">
          <a class="btn btn-outline-primary" href="https://www.airbnb.com/" target="_blank">Book Now</a>
        </div>
      </div>
    </div>

  </section>

  <hr class="my-5">


  <section id="hostel">
    <h3 class="mb-3">Hostels <sup class="fs-5">(1)</sup></h3>

    <div class="row">
      <div class="card col-md-3">
        <div class="card-header">
          <h4>Yellow Leaf Home</h4>
        </div>
        <div class="card-content">
          <img src="../../../../assets/images/elementor-placeholder-image.webp" class="card-img">

          <p class="m-3">
            The Yellow Leaf Home is the only hostel on the island but sits directly in the beautify Yellow Leaf Bay.
            It sleeps up to 50 individuals and is perfect for those who plan on experiencing the island and need a pillow
            to sleep on at the end of the day.
          </p>

          <a class="btn btn-outline-primary mt-2 mb-4" href="#" target="_blank">Reserve A Bed</a>
        </div>
      </div>
    </div>

  </section>

</div>
